import request from '@/utils/request'

export function getMenuTree() {
  return request({
    url: '/api/menu/tree',
    method: 'get'
  })
}

export function getMenuList() {
  return request({
    url: '/api/menu/list',
    method: 'get'
  })
}

export function createMenu(data) {
  return request({
    url: '/api/menu',
    method: 'post',
    data
  })
}

export function updateMenu(data) {
  return request({
    url: '/api/menu',
    method: 'post',
    data
  })
}

export function deleteMenu(id) {
  return request({
    url: `/api/menu/${id}`,
    method: 'delete'
  })
}

export function updateMenuStatus(id, status) {
  return request({
    url: `/api/menu/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function getMenusByRoleId(roleId) {
  return request({
    url: `/api/menu/menus/${roleId}`,
    method: 'get'
  })
}
